export default __webpack_public_path__ + "static/media/1.699f5a33.png";